import React from "react";
import { Table } from "react-bootstrap";
import PropTypes from "prop-types";
import "./ProjectTableComponent.css"

const ProjectTableComponent = ({
  title,
  status,
  scopeWord
}) => {
  return (
    <Table bordered hover responsive className="project-table-wrapper">
      <tbody>
        <tr>
          <td><strong>Work:</strong></td>
          <td>{title}</td>
        </tr>
        <tr>
          <td><strong>Status:</strong></td>
          <td>{status}</td>
        </tr>
        {scopeWord && scopeWord.length > 0 && (
          <tr>
            <td><strong>Scope of Work:</strong></td>
            <td>
              {scopeWord.map((scope, index) => (
                <span key={index}>
                  {scope}
                  {index !== scopeWord.length - 1 && ", "}
                </span>
              ))}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

ProjectTableComponent.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  scopeWord: PropTypes.array.isRequired,
};

export default ProjectTableComponent;